import { useEffect } from "react";

export const useKeyboardShortcuts = ({ actions }) => {
  // actions should be an object with keys as keyboard shortcut and values as functions
  // i.e. { ctrlEnter: () => console.log("ctrl + enter pressed") }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
        actions["ctrlEnter"] && actions["ctrlEnter"]();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [actions]);
};

export default useKeyboardShortcuts;
